import React from "react";
import { Col, Row, Tag, Flex } from "antd";
import dayjs from "dayjs";
import { formatIndianCurrency } from "../../../../../utills/helpers";

const Step3DetailsSection = ({ leadViewDetails, renderFileLinks }) => {
  const mechanicalDetail =
    leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail;

  const formatValue = (value, type = "text") => {
    if (value === null || value === undefined || value === "") {
      return <p className="value">-</p>;
    }

    switch (type) {
      case "currency":
        return <p>{formatIndianCurrency(value)}</p>;
      case "date":
        return <p className="value">{dayjs(value).format("DD/MM/YYYY")}</p>;
      case "boolean":
        return (
          <Tag
            color={
              value === "Yes" ? "green" : value === "No" ? "red" : "default"
            }
            style={{ fontSize: "10px", margin: 0 }}
          >
            {value}
          </Tag>
        );
      case "percentage":
        return <p className="value">{value}%</p>;
      default:
        return <p className="value">{value}</p>;
    }
  };

  const DetailItem = ({
    label,
    value,
    type = "text",
    cost = null,
    files = null,
  }) => (
    <Flex align="start" vertical>
      <Flex align="center" className="view-fields test1 w-100">
        <h6>{label}:</h6>
        {formatValue(value, type)}
      </Flex>
      {cost >= 0 && (
        <Flex className=" w-100">
          <Flex align="center" className="view-fields test2 w-100">
            <h6>Cost:</h6>
            <Flex align="center" gap={10} className="value">
              {formatValue(cost, "currency")}
              {files && renderFileLinks(files, false)}
            </Flex>
          </Flex>
        </Flex>
      )}
    </Flex>
  );

  return (
    <div style={{ padding: "16px 0" }}>
      <Row gutter={[24, 24]}>
        {/* Section 1 - Transmission & Drivetrain (10 fields) */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Clutch Defect"
            value={mechanicalDetail?.clutch_defect}
            type="boolean"
            cost={
              mechanicalDetail?.clutch_defect === "Yes"
                ? mechanicalDetail?.clutch_defect_cost
                : null
            }
            files={
              mechanicalDetail?.clutch_defect === "Yes"
                ? ["Clutch Defect"]
                : null
            }
          />
          <DetailItem
            label="Transmission Oil Leak"
            value={mechanicalDetail?.transmission_oil_leak}
            type="boolean"
            cost={
              mechanicalDetail?.transmission_oil_leak === "Yes"
                ? mechanicalDetail?.transmission_oil_leak_cost
                : null
            }
            files={
              mechanicalDetail?.transmission_oil_leak === "Yes"
                ? ["Transmission Oil Leak"]
                : null
            }
          />
          <DetailItem
            label="Shift Shock Time Lag"
            value={mechanicalDetail?.shift_shock_time_lag}
            type="boolean"
            cost={
              mechanicalDetail?.shift_shock_time_lag === "Yes"
                ? mechanicalDetail?.shift_shock_time_lag_cost
                : null
            }
            files={
              mechanicalDetail?.shift_shock_time_lag === "Yes"
                ? ["Shift Shock Time Lag"]
                : null
            }
          />
          <DetailItem
            label="GearBox Defect"
            value={mechanicalDetail?.gearbox_defect}
            type="boolean"
            cost={
              mechanicalDetail?.gearbox_defect === "Yes"
                ? mechanicalDetail?.gearbox_defect_cost
                : null
            }
            files={
              mechanicalDetail?.gearbox_defect === "Yes"
                ? ["GearBox Defect"]
                : null
            }
          />
          <DetailItem
            label="Drive Shaft Defect"
            value={mechanicalDetail?.drive_shaft_defect}
            type="boolean"
            cost={
              mechanicalDetail?.drive_shaft_defect === "Yes"
                ? mechanicalDetail?.drive_shaft_defect_cost
                : null
            }
            files={
              mechanicalDetail?.drive_shaft_defect === "Yes"
                ? ["Drive Shaft Defect"]
                : null
            }
          />
          <DetailItem
            label="Boot Cut"
            value={mechanicalDetail?.boot_cut}
            type="boolean"
            cost={
              mechanicalDetail?.boot_cut === "Yes"
                ? mechanicalDetail?.boot_cut_cost
                : null
            }
            files={mechanicalDetail?.boot_cut === "Yes" ? ["Boot Cut"] : null}
          />
          <DetailItem
            label="Differential Noise"
            value={mechanicalDetail?.differential_noise}
            type="boolean"
            cost={
              mechanicalDetail?.differential_noise === "Yes"
                ? mechanicalDetail?.differential_noise_cost
                : null
            }
            files={
              mechanicalDetail?.differential_noise === "Yes"
                ? ["Differential Noise"]
                : null
            }
          />
          <DetailItem
            label="Wheel Noise Defect"
            value={mechanicalDetail?.wheel_noise_defect}
            type="boolean"
            cost={
              mechanicalDetail?.wheel_noise_defect === "Yes"
                ? mechanicalDetail?.wheel_noise_defect_cost
                : null
            }
            files={
              mechanicalDetail?.wheel_noise_defect === "Yes"
                ? ["Wheel Noise Defect"]
                : null
            }
          />
          <DetailItem
            label="Modified Suspension"
            value={mechanicalDetail?.modified_suspension}
            type="boolean"
            cost={
              mechanicalDetail?.modified_suspension === "Yes"
                ? mechanicalDetail?.modified_suspension_cost
                : null
            }
            files={
              mechanicalDetail?.modified_suspension === "Yes"
                ? ["Modified Suspension"]
                : null
            }
          />
        </Col>

        {/* Section 2 - Steering & Panels (10 fields) */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Steering Noise"
            value={mechanicalDetail?.steering_noise}
            type="boolean"
            cost={
              mechanicalDetail?.steering_noise === "Yes"
                ? mechanicalDetail?.steering_noise_cost
                : null
            }
            files={
              mechanicalDetail?.steering_noise === "Yes"
                ? ["Steering Noise"]
                : null
            }
          />
          <DetailItem
            label="Steering Oil Leak"
            value={mechanicalDetail?.steering_oil_leak}
            type="boolean"
            cost={
              mechanicalDetail?.steering_oil_leak === "Yes"
                ? mechanicalDetail?.steering_oil_leak_cost
                : null
            }
            files={
              mechanicalDetail?.steering_oil_leak === "Yes"
                ? ["Steering Oil Leak"]
                : null
            }
          />
          <DetailItem
            label="Steering Shaft Boot Cut"
            value={mechanicalDetail?.steering_shaft_boot_cut}
            type="boolean"
            cost={
              mechanicalDetail?.steering_shaft_boot_cut === "Yes"
                ? mechanicalDetail?.steering_shaft_boot_cut_cost
                : null
            }
            files={
              mechanicalDetail?.steering_shaft_boot_cut === "Yes"
                ? ["Steering Shaft Boot Cut"]
                : null
            }
          />
          <DetailItem
            label="Jammed Steering"
            value={mechanicalDetail?.jammed_steering}
            type="boolean"
            cost={
              mechanicalDetail?.jammed_steering === "Yes"
                ? mechanicalDetail?.jammed_steering_cost
                : null
            }
            files={
              mechanicalDetail?.jammed_steering === "Yes"
                ? ["Jammed Steering"]
                : null
            }
          />
          <DetailItem
            label="Defective Telescopic Tilt"
            value={mechanicalDetail?.defective_telescopic_tilt}
            type="boolean"
            cost={
              mechanicalDetail?.defective_telescopic_tilt === "Yes"
                ? mechanicalDetail?.defective_telescopic_tilt_cost
                : null
            }
            files={
              mechanicalDetail?.defective_telescopic_tilt === "Yes"
                ? ["Defective Telescopic Tilt"]
                : null
            }
          />
          <DetailItem
            label="RH Rocker Panel"
            value={mechanicalDetail?.rh_rocker_panel}
            cost={
              mechanicalDetail?.rh_rocker_panel &&
              mechanicalDetail?.rh_rocker_panel !== "Ok"
                ? mechanicalDetail?.rh_rocker_panel_cost
                : null
            }
            files={
              mechanicalDetail?.rh_rocker_panel &&
              mechanicalDetail?.rh_rocker_panel !== "Ok"
                ? ["RH Rocker Panel"]
                : null
            }
          />
          <DetailItem
            label="LH Rocker Panel"
            value={mechanicalDetail?.lh_rocker_panel}
            cost={
              mechanicalDetail?.lh_rocker_panel &&
              mechanicalDetail?.lh_rocker_panel !== "Ok"
                ? mechanicalDetail?.lh_rocker_panel_cost
                : null
            }
            files={
              mechanicalDetail?.lh_rocker_panel &&
              mechanicalDetail?.lh_rocker_panel !== "Ok"
                ? ["LH Rocker Panel"]
                : null
            }
          />
          <DetailItem
            label="RH Rear Fender Panel"
            value={mechanicalDetail?.rh_rear_fender_panel}
            cost={
              mechanicalDetail?.rh_rear_fender_panel &&
              mechanicalDetail?.rh_rear_fender_panel !== "Ok"
                ? mechanicalDetail?.rh_rear_fender_panel_cost
                : null
            }
            files={
              mechanicalDetail?.rh_rear_fender_panel &&
              mechanicalDetail?.rh_rear_fender_panel !== "Ok"
                ? ["RH Rear Fender Panel"]
                : null
            }
          />
          <DetailItem
            label="LH Rear Fender Panel"
            value={mechanicalDetail?.lh_rear_fender_panel}
            cost={
              mechanicalDetail?.lh_rear_fender_panel &&
              mechanicalDetail?.lh_rear_fender_panel !== "Ok"
                ? mechanicalDetail?.lh_rear_fender_panel_cost
                : null
            }
            files={
              mechanicalDetail?.lh_rear_fender_panel &&
              mechanicalDetail?.lh_rear_fender_panel !== "Ok"
                ? ["LH Rear Fender Panel"]
                : null
            }
          />
          <DetailItem
            label="End Panel"
            value={mechanicalDetail?.end_panel}
            cost={
              mechanicalDetail?.end_panel &&
              mechanicalDetail?.end_panel !== "Ok"
                ? mechanicalDetail?.end_panel_cost
                : null
            }
            files={
              mechanicalDetail?.end_panel &&
              mechanicalDetail?.end_panel !== "Ok"
                ? ["End Panel"]
                : null
            }
          />
          <DetailItem
            label="Jack Tools Kit"
            value={mechanicalDetail?.jack_tools_kit}
            type="boolean"
            cost={
              mechanicalDetail?.jack_tools_kit === "Yes"
                ? mechanicalDetail?.jack_tools_kit_cost
                : null
            }
            files={
              mechanicalDetail?.jack_tools_kit === "Yes"
                ? ["Jack Tools Kit"]
                : null
            }
          />
        </Col>

        {/* Section 3 - Tyres & Wheels (10 fields) */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Front Tyre Left"
            value={mechanicalDetail?.front_tyre_left}
            type="percentage"
            cost={mechanicalDetail?.front_tyre_left_cost}
            files={["Front Tyre Left"]}
          />
          <DetailItem
            label="Front Tyre Right"
            value={mechanicalDetail?.front_tyre_right}
            type="percentage"
            cost={mechanicalDetail?.front_tyre_right_cost}
            files={["Front Tyre Right"]}
          />
          <DetailItem
            label="Back Tyre Left"
            value={mechanicalDetail?.back_tyre_left}
            type="percentage"
            cost={mechanicalDetail?.back_tyre_left_cost}
            files={["Back Tyre Left"]}
          />
          <DetailItem
            label="Back Tyre Right"
            value={mechanicalDetail?.back_tyre_right}
            type="percentage"
            cost={mechanicalDetail?.back_tyre_right_cost}
            files={["Back Tyre Right"]}
          />
          <DetailItem
            label="Spare Wheels"
            value={mechanicalDetail?.spare_wheels}
            type="boolean"
            cost={
              mechanicalDetail?.spare_wheels === "Yes"
                ? mechanicalDetail?.spare_wheels_cost
                : null
            }
            files={
              mechanicalDetail?.spare_wheels === "Yes" ? ["Spare Wheels"] : null
            }
          />
          <DetailItem
            label="Front Spoiler"
            value={mechanicalDetail?.front_spoiler}
            cost={
              mechanicalDetail?.front_spoiler &&
              mechanicalDetail?.front_spoiler !== "Ok"
                ? mechanicalDetail?.front_spoiler_cost
                : null
            }
            files={
              mechanicalDetail?.front_spoiler &&
              mechanicalDetail?.front_spoiler !== "Ok"
                ? ["Front Spoiler"]
                : null
            }
          />
          <DetailItem
            label="Front Bumper"
            value={mechanicalDetail?.front_bumper}
            cost={
              mechanicalDetail?.front_bumper &&
              mechanicalDetail?.front_bumper !== "Ok"
                ? mechanicalDetail?.front_bumper_cost
                : null
            }
            files={
              mechanicalDetail?.front_bumper &&
              mechanicalDetail?.front_bumper !== "Ok"
                ? ["Front Bumper"]
                : null
            }
          />
          <DetailItem
            label="Grill"
            value={mechanicalDetail?.grill}
            cost={
              mechanicalDetail?.grill && mechanicalDetail?.grill !== "Ok"
                ? mechanicalDetail?.grill_cost
                : null
            }
            files={
              mechanicalDetail?.grill && mechanicalDetail?.grill !== "Ok"
                ? ["Grill"]
                : null
            }
          />
        </Col>

        {/* Section 4 - Lights, Paint & Accessories (10 fields) */}
        <Col xs={24} sm={12} md={12}>
          <DetailItem
            label="Rear Bumper"
            value={mechanicalDetail?.rear_bumper}
            cost={
              mechanicalDetail?.rear_bumper &&
              mechanicalDetail?.rear_bumper !== "Ok"
                ? mechanicalDetail?.rear_bumper_cost
                : null
            }
            files={
              mechanicalDetail?.rear_bumper &&
              mechanicalDetail?.rear_bumper !== "Ok"
                ? ["Rear Bumper"]
                : null
            }
          />
          <DetailItem
            label="Rear Spoiler"
            value={mechanicalDetail?.rear_spoiler}
            cost={
              mechanicalDetail?.rear_spoiler &&
              mechanicalDetail?.rear_spoiler !== "Ok"
                ? mechanicalDetail?.rear_spoiler_cost
                : null
            }
            files={
              mechanicalDetail?.rear_spoiler &&
              mechanicalDetail?.rear_spoiler !== "Ok"
                ? ["Rear Spoiler"]
                : null
            }
          />
          <DetailItem
            label="Head Light"
            value={mechanicalDetail?.head_light}
            cost={
              mechanicalDetail?.head_light &&
              mechanicalDetail?.head_light !== "Ok"
                ? mechanicalDetail?.head_light_cost
                : null
            }
            files={
              mechanicalDetail?.head_light &&
              mechanicalDetail?.head_light !== "Ok"
                ? ["Head Light"]
                : null
            }
          />
          <DetailItem
            label="Tail Light"
            value={mechanicalDetail?.tail_light}
            cost={
              mechanicalDetail?.tail_light &&
              mechanicalDetail?.tail_light !== "Ok"
                ? mechanicalDetail?.tail_light_cost
                : null
            }
            files={
              mechanicalDetail?.tail_light &&
              mechanicalDetail?.tail_light !== "Ok"
                ? ["Tail Light"]
                : null
            }
          />
          <DetailItem
            label="Fog Lamp"
            value={mechanicalDetail?.fog_lamp}
            cost={
              mechanicalDetail?.fog_lamp && mechanicalDetail?.fog_lamp !== "Ok"
                ? mechanicalDetail?.fog_lamp_cost
                : null
            }
            files={
              mechanicalDetail?.fog_lamp && mechanicalDetail?.fog_lamp !== "Ok"
                ? ["Fog Lamp"]
                : null
            }
          />
          <DetailItem
            label="Side Mirror"
            value={mechanicalDetail?.side_mirror}
            cost={
              mechanicalDetail?.side_mirror &&
              mechanicalDetail?.side_mirror !== "Ok"
                ? mechanicalDetail?.side_mirror_cost
                : null
            }
            files={
              mechanicalDetail?.side_mirror &&
              mechanicalDetail?.side_mirror !== "Ok"
                ? ["Side Mirror"]
                : null
            }
          />
          <DetailItem
            label="Mud Flap"
            value={mechanicalDetail?.mud_flap}
            cost={
              mechanicalDetail?.mud_flap && mechanicalDetail?.mud_flap !== "Ok"
                ? mechanicalDetail?.mud_flap_cost
                : null
            }
            files={
              mechanicalDetail?.mud_flap && mechanicalDetail?.mud_flap !== "Ok"
                ? ["Mud Flap"]
                : null
            }
          />
          <DetailItem
            label="Wind Shield Glass "
            value={mechanicalDetail?.windshield_glass}
            cost={
              mechanicalDetail?.windshield_glass &&
              mechanicalDetail?.windshield_glass !== "Ok"
                ? mechanicalDetail?.windshield_glass_cost
                : null
            }
            files={
              mechanicalDetail?.windshield_glass &&
              mechanicalDetail?.windshield_glass !== "Ok"
                ? ["Windsheild Glass "]
                : null
            }
          />
          <DetailItem
            label="Wheel Cover"
            value={mechanicalDetail?.wheel_cover}
            cost={
              mechanicalDetail?.wheel_cover &&
              mechanicalDetail?.wheel_cover !== "Ok"
                ? mechanicalDetail?.wheel_cover_cost
                : null
            }
            files={
              mechanicalDetail?.wheel_cover &&
              mechanicalDetail?.wheel_cover !== "Ok"
                ? ["Wheel Cover"]
                : null
            }
          />
          <DetailItem
            label="Weather Strip"
            value={mechanicalDetail?.weather_strip}
            cost={
              mechanicalDetail?.weather_strip &&
              mechanicalDetail?.weather_strip !== "Ok"
                ? mechanicalDetail?.weather_strip_cost
                : null
            }
            files={
              mechanicalDetail?.weather_strip &&
              mechanicalDetail?.weather_strip !== "Ok"
                ? ["Weather Strip"]
                : null
            }
          />
          <DetailItem
            label="Logo Missing"
            value={mechanicalDetail?.logo_missing}
            cost={
              mechanicalDetail?.logo_missing &&
              mechanicalDetail?.logo_missing !== "Ok"
                ? mechanicalDetail?.logo_missing_cost
                : null
            }
            files={
              mechanicalDetail?.logo_missing &&
              mechanicalDetail?.logo_missing !== "Ok"
                ? ["Logo Missing"]
                : null
            }
          />
          <DetailItem
            label="Door Lock Defect"
            value={mechanicalDetail?.door_lock_defect}
            type="boolean"
            cost={
              mechanicalDetail?.door_lock_defect === "Yes"
                ? mechanicalDetail?.door_lock_defect_cost
                : null
            }
            files={
              mechanicalDetail?.door_lock_defect === "Yes"
                ? ["Door Lock Defect"]
                : null
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default Step3DetailsSection;
